// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ZonesAndClustersRepoConfig from "./ZonesAndClustersRepoConfig.bs.js";

var dummy_zones_list = {
  "zones": [
    {
      "id": 7,
      "description": "Navi Mumbai"
    },
    {
      "id": 35,
      "description": "Andheri"
    },
    {
      "id": 9,
      "description": "Govandi"
    },
    {
      "id": 8,
      "description": "Mira Bhayanadar"
    },
    {
      "id": 36,
      "description": "Mulund"
    },
    {
      "id": 34,
      "description": "South Mumbai"
    },
    {
      "id": 37,
      "description": "Thane"
    },
    {
      "id": 10,
      "description": "Virar-Vasai"
    },
    {
      "id": 1,
      "description": "Goregaon"
    }
  ]
};

var dummy_clusters_list = {
  "clusters": [
    {
      "id": 310,
      "name": "New Panvel",
      "zone_id": null
    },
    {
      "id": 322,
      "name": "Ovale",
      "zone_id": 37
    },
    {
      "id": 319,
      "name": "Waghle",
      "zone_id": 37
    },
    {
      "id": 334,
      "name": "Dahisar East",
      "zone_id": 1
    },
    {
      "id": 333,
      "name": "Dahisar West",
      "zone_id": 1
    },
    {
      "id": 337,
      "name": "Ghodbunder",
      "zone_id": 8
    },
    {
      "id": 346,
      "name": "Virar West",
      "zone_id": 10
    },
    {
      "id": 360,
      "name": "Govandi",
      "zone_id": 9
    },
    {
      "id": 363,
      "name": "Kasheli",
      "zone_id": 6
    },
    {
      "id": 362,
      "name": "Mahul",
      "zone_id": 9
    },
    {
      "id": 338,
      "name": "Mira Bhayander",
      "zone_id": 8
    },
    {
      "id": 347,
      "name": "Virar East",
      "zone_id": 10
    },
    {
      "id": 330,
      "name": "Aarey",
      "zone_id": 1
    },
    {
      "id": 331,
      "name": "Charkop",
      "zone_id": 1
    },
    {
      "id": 287,
      "name": "Byculla",
      "zone_id": 34
    },
    {
      "id": 284,
      "name": "Dombivli",
      "zone_id": 11
    },
    {
      "id": 286,
      "name": "Powai",
      "zone_id": 35
    },
    {
      "id": 364,
      "name": "Purna",
      "zone_id": 6
    },
    {
      "id": 361,
      "name": "Anushakti Nagar",
      "zone_id": 9
    },
    {
      "id": 356,
      "name": "Marol",
      "zone_id": 35
    },
    {
      "id": 366,
      "name": "Dapode",
      "zone_id": 6
    },
    {
      "id": 348,
      "name": "Khanivade",
      "zone_id": 10
    },
    {
      "id": 367,
      "name": "Pimplas",
      "zone_id": 6
    },
    {
      "id": 353,
      "name": "Saki Naka",
      "zone_id": 35
    },
    {
      "id": 352,
      "name": "Versova",
      "zone_id": 35
    },
    {
      "id": 349,
      "name": "Jogeshwari West",
      "zone_id": 35
    },
    {
      "id": 350,
      "name": "Lokhandwala",
      "zone_id": 35
    },
    {
      "id": 329,
      "name": "Goregaon East",
      "zone_id": 1
    },
    {
      "id": 318,
      "name": "Mulund",
      "zone_id": 36
    },
    {
      "id": 336,
      "name": "Boriwali West",
      "zone_id": 1
    },
    {
      "id": 332,
      "name": "Kandiwali West",
      "zone_id": 1
    },
    {
      "id": 359,
      "name": "Chembur",
      "zone_id": 9
    },
    {
      "id": 341,
      "name": "Dongri",
      "zone_id": 8
    },
    {
      "id": 351,
      "name": "Andheri West",
      "zone_id": 35
    },
    {
      "id": 339,
      "name": "Gorai",
      "zone_id": 8
    },
    {
      "id": 340,
      "name": "Uttan",
      "zone_id": 8
    },
    {
      "id": 320,
      "name": "Majiwada",
      "zone_id": 37
    },
    {
      "id": 344,
      "name": "Naigaon",
      "zone_id": 10
    },
    {
      "id": 345,
      "name": "Nalasopara",
      "zone_id": 10
    },
    {
      "id": 343,
      "name": "Vasai East",
      "zone_id": 10
    },
    {
      "id": 342,
      "name": "Vasai West",
      "zone_id": 10
    },
    {
      "id": 296,
      "name": "Dadar",
      "zone_id": 34
    },
    {
      "id": 316,
      "name": "Vashi",
      "zone_id": 7
    },
    {
      "id": 313,
      "name": "Kalwa",
      "zone_id": 37
    },
    {
      "id": 312,
      "name": "Kharegaon",
      "zone_id": 37
    },
    {
      "id": 299,
      "name": "Mumbai Central",
      "zone_id": 34
    },
    {
      "id": 321,
      "name": "Shivai Nagar",
      "zone_id": 37
    },
    {
      "id": 355,
      "name": "Saki Vihar",
      "zone_id": 35
    },
    {
      "id": 311,
      "name": "Vikhroli",
      "zone_id": 36
    },
    {
      "id": 309,
      "name": "Taloje",
      "zone_id": 7
    },
    {
      "id": 335,
      "name": "Boriwali East",
      "zone_id": 1
    },
    {
      "id": 326,
      "name": "Kharodi",
      "zone_id": 1
    },
    {
      "id": 328,
      "name": "Malad East",
      "zone_id": 1
    },
    {
      "id": 324,
      "name": "Agra Road",
      "zone_id": 37
    },
    {
      "id": 323,
      "name": "Patlipada",
      "zone_id": 37
    },
    {
      "id": 308,
      "name": "Kharghar",
      "zone_id": 7
    },
    {
      "id": 357,
      "name": "Andheri East",
      "zone_id": 35
    },
    {
      "id": 314,
      "name": "Airoli",
      "zone_id": 37
    },
    {
      "id": 315,
      "name": "Rabale",
      "zone_id": 37
    },
    {
      "id": 288,
      "name": "Ulwe",
      "zone_id": 7
    },
    {
      "id": 292,
      "name": "Vile Parle East",
      "zone_id": 35
    },
    {
      "id": 293,
      "name": "Bandra East",
      "zone_id": 35
    },
    {
      "id": 365,
      "name": "Anjurphata",
      "zone_id": 6
    },
    {
      "id": 307,
      "name": "Padgha",
      "zone_id": 6
    },
    {
      "id": 302,
      "name": "Bandra West",
      "zone_id": 35
    },
    {
      "id": 354,
      "name": "Jogeshwari East",
      "zone_id": 35
    },
    {
      "id": 285,
      "name": "Juhu",
      "zone_id": 35
    },
    {
      "id": 358,
      "name": "Kurla",
      "zone_id": 9
    },
    {
      "id": 294,
      "name": "Pogaon",
      "zone_id": 6
    },
    {
      "id": 295,
      "name": "Sonale",
      "zone_id": 6
    },
    {
      "id": 298,
      "name": "Ambernath",
      "zone_id": 11
    },
    {
      "id": 305,
      "name": "Kalyan",
      "zone_id": 11
    },
    {
      "id": 327,
      "name": "Goregaon West",
      "zone_id": 1
    },
    {
      "id": 291,
      "name": "Kandivali East",
      "zone_id": 1
    },
    {
      "id": 325,
      "name": "Malad West",
      "zone_id": 1
    },
    {
      "id": 303,
      "name": "Antop Hill",
      "zone_id": 9
    },
    {
      "id": 289,
      "name": "Dharavi",
      "zone_id": 9
    },
    {
      "id": 297,
      "name": "Ghatkopar",
      "zone_id": 9
    },
    {
      "id": 368,
      "name": "Kopar Khairane",
      "zone_id": 7
    },
    {
      "id": 306,
      "name": "Nerul",
      "zone_id": 7
    },
    {
      "id": 317,
      "name": "Sanpada",
      "zone_id": 7
    },
    {
      "id": 300,
      "name": "Churchgate",
      "zone_id": 34
    },
    {
      "id": 304,
      "name": "Grant Road",
      "zone_id": 34
    },
    {
      "id": 290,
      "name": "Lower Parel",
      "zone_id": 34
    },
    {
      "id": 301,
      "name": "Parel",
      "zone_id": 34
    }
  ]
};

function fetchZones(_geo_region_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummy_zones_list
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ZonesAndClustersRepoConfig.ZoneListResponseConverter.execute, result);
                        });
            });
}

function fetchClusters(_geo_region_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummy_clusters_list
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ZonesAndClustersRepoConfig.ClusterListResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchZones: fetchZones,
  fetchClusters: fetchClusters
};

export {
  T ,
  
}
/* ZonesAndClustersRepoConfig Not a pure module */
